module.exports = __webpack_public_path__ + "static/media/gås-min.0048ad18.png";